import { Link } from "@/i18n/navigation";
import { Heart } from "lucide-react";

export function Logo() {
	return (
		<Link
			href="/"
			className="flex items-center gap-1 font-semibold text-foreground"
		>
			<Heart className="h-6 w-6 text-primary" aria-hidden />
			<span>
				<span className="text-primary font-bold">Lov</span>Page
			</span>
		</Link>
	);
}
